module.exports = __webpack_public_path__ + "static/img/xiaolaba.5adef727.png";